var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ul",
    _vm._l(_vm.sessions, function (item) {
      return _c(
        "li",
        {
          key: item.id,
          ref: item.id + "Ref",
          refInFor: true,
          staticClass:
            "d-table w-100-p h-67 b-b b-c-g-100 cursor-default bg-g-50-hover",
          class: { "bg-g-100": item.id === _vm.toAccount },
          on: {
            click: function ($event) {
              return _vm.itemClickEvent(item)
            },
          },
        },
        [
          item.scene === "p2p"
            ? _c(
                "div",
                {
                  staticClass: "d-table-cell v-a-middle h-100-p w-64",
                  staticStyle: { "text-align": "center" },
                },
                [
                  item.to.length == 32 &&
                  item.to != _vm.$store.state.user.loginId
                    ? _c(
                        "span",
                        {
                          staticClass:
                            "d-block m-auto w-40 h-40 l-h-40 t-a-center c-white rounded user-select-none",
                          staticStyle: { "background-color": "#653EB3" },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.getShortNickname(
                                  item.userInfo.nickName
                                    ? item.userInfo.nickName
                                    : item.userInfo.mobile
                                    ? item.userInfo.mobile
                                    : item.userInfo.userName
                                    ? item.userInfo.userName
                                    : item.userInfo.tel
                                )
                              ) +
                              " "
                          ),
                        ]
                      )
                    : item.to.length != 32 &&
                      item.to != _vm.$store.state.user.loginId
                    ? _c("img", {
                        staticStyle: { width: "40px", height: "40px" },
                        attrs: { src: require("@/assets/images/im/kefu.svg") },
                      })
                    : item.to == _vm.$store.state.user.loginId
                    ? _c("img", {
                        staticStyle: { width: "40px", height: "40px" },
                        attrs: { src: require("@/assets/images/im/laba.png") },
                      })
                    : _vm._e(),
                ]
              )
            : _vm._e(),
          item.scene === "team" && item.userInfo.serverCustom
            ? _c(
                "div",
                {
                  staticClass: "d-table-cell v-a-middle h-100-p w-64",
                  staticStyle: { "text-align": "center" },
                },
                [
                  item.userInfo.avatar
                    ? _c("img", {
                        staticStyle: { width: "40px", height: "40px" },
                        attrs: { src: item.userInfo.avatar },
                      })
                    : _c("img", {
                        staticStyle: { width: "40px", height: "40px" },
                        attrs: {
                          src: require("@/assets/images/im/zhuanShu@2x.png"),
                        },
                      }),
                ]
              )
            : _vm._e(),
          item.scene === "team" && !item.userInfo.serverCustom
            ? _c(
                "div",
                {
                  staticClass:
                    "d-table-cell v-a-middle h-100-p w-64 t-a-center",
                },
                [
                  _c("img", {
                    staticStyle: { width: "40px", height: "40px" },
                    attrs: { src: require("@/assets/images/im/team-cus.png") },
                  }),
                ]
              )
            : _vm._e(),
          _c(
            "div",
            { staticClass: "p-relative d-table-cell v-a-middle h-100-p" },
            [
              _c("div", { style: { width: _vm.listWidth + "px" } }, [
                item.scene === "p2p"
                  ? _c("div", [
                      item.to.length == 32 &&
                      item.to != _vm.$store.state.user.loginId
                        ? _c(
                            "p",
                            {
                              staticClass: "t-ellipsis l-h-1-6-em m-r-10",
                              attrs: { "data-type": JSON.stringify(item) },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  item.userInfo.nickName
                                    ? item.userInfo.nickName
                                    : item.userInfo.mobile
                                    ? item.userInfo.mobile
                                    : item.userInfo.userName
                                    ? item.userInfo.userName
                                    : item.userInfo.tel
                                )
                              ),
                            ]
                          )
                        : item.to.length != 32 &&
                          item.to != _vm.$store.state.user.loginId
                        ? _c(
                            "p",
                            { staticClass: "t-ellipsis l-h-1-6-em m-r-10" },
                            [
                              _vm._v(_vm._s(item.userInfo.userName || "")),
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: item.userInfo.userName,
                                      expression: "item.userInfo.userName",
                                    },
                                  ],
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      item.userInfo.stationName
                                        ? "-" + item.userInfo.stationName
                                        : ""
                                    )
                                  ),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      item.to == _vm.$store.state.user.loginId
                        ? _c(
                            "p",
                            {
                              staticClass: "t-ellipsis l-h-1-6-em m-r-10",
                              attrs: { "data-type": JSON.stringify(item) },
                            },
                            [_vm._v("群通知")]
                          )
                        : _vm._e(),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                !item.userInfo.userName &&
                                !item.userInfo.stationName,
                              expression:
                                "!item.userInfo.userName&&!item.userInfo.stationName",
                            },
                          ],
                        },
                        [_vm._v(_vm._s(item.userInfo.userCode))]
                      ),
                      _c("p"),
                      item.id != _vm.toAccount && item.abstract
                        ? _c("p", {
                            staticClass:
                              "t-ellipsis l-h-1-6-em m-r-10 f-s-12 c-g-400 flex",
                            domProps: { innerHTML: _vm._s(item.abstract) },
                          })
                        : _c(
                            "p",
                            {
                              staticClass:
                                "t-ellipsis l-h-1-6-em m-r-10 f-s-12 c-g-400",
                            },
                            [_vm._v(_vm._s(_vm.lastMsgCp(item)))]
                          ),
                    ])
                  : _vm._e(),
                item.scene === "team"
                  ? _c("div", [
                      _c("p", { staticClass: "t-ellipsis l-h-1-6-em m-r-10" }, [
                        _vm._v(_vm._s(item.userInfo.name)),
                      ]),
                      item.id != _vm.toAccount && item.abstract
                        ? _c("p", {
                            staticClass:
                              "t-ellipsis l-h-1-6-em m-r-10 f-s-12 c-g-400 flex",
                            domProps: { innerHTML: _vm._s(item.abstract) },
                          })
                        : _c(
                            "p",
                            {
                              staticClass:
                                "t-ellipsis l-h-1-6-em m-r-10 f-s-12 c-g-400",
                            },
                            [
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: item.appointText,
                                      expression: "item.appointText",
                                    },
                                  ],
                                  staticStyle: { color: "#fb1010" },
                                },
                                [_vm._v(_vm._s(_vm.removal(item.appointText)))]
                              ),
                              _vm._v(_vm._s(_vm.lastMsgCp(item))),
                            ]
                          ),
                    ])
                  : _vm._e(),
                item.muteNotiType == 1
                  ? _c("img", {
                      staticClass: "mute-logo",
                      attrs: { src: require("@/assets/images/im/mute.png") },
                    })
                  : _vm._e(),
                item.istop
                  ? _c("img", {
                      staticClass: "top-logo",
                      attrs: { src: require("@/assets/images/im/istop.png") },
                    })
                  : _vm._e(),
                item.unread > 0
                  ? _c(
                      "span",
                      {
                        staticClass:
                          "p-absolute right-6 bottom-32 p-x-5 f-s-12 l-h-1-4-em c-white",
                        style: {
                          "background-color": "#f33232",
                          "border-radius": "10px",
                          "font-size": item.muteNotiType == 1 ? "10px" : "12px",
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(item.muteNotiType == 1 ? " " : item.unread)
                        ),
                      ]
                    )
                  : _vm._e(),
              ]),
            ]
          ),
          _c(
            "im-context-menu",
            {
              ref: item.id + "ContextRef",
              refInFor: true,
              attrs: {
                "target-parent-ref": _vm.$refs,
                "target-ref-name": item.id + "Ref",
              },
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "p-absolute z-index-1 m-l-10 bg-white b b-c-g-100 r-4 shadow-3-g-100",
                  staticStyle: { width: "120px" },
                },
                [
                  item.scene === "p2p"
                    ? _c("div", [
                        _c(
                          "p",
                          {
                            staticClass:
                              "p-x-10 p-y-6 m-t-8 cursor-pointer bg-g-50-hover",
                            on: {
                              click: function ($event) {
                                return _vm.addStickTopSession(item)
                              },
                            },
                          },
                          [_vm._v(_vm._s(item.istop ? "取消置顶" : "置顶会话"))]
                        ),
                        _c(
                          "p",
                          {
                            staticClass:
                              "p-x-10 p-y-6 m-t-8 cursor-pointer bg-g-50-hover",
                            on: {
                              click: function ($event) {
                                return _vm.markInMutelist(item)
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                item.muteNotiType == 1
                                  ? "开启消息提醒"
                                  : "消息免打扰"
                              )
                            ),
                          ]
                        ),
                        _c(
                          "p",
                          {
                            staticClass:
                              "p-x-10 p-y-6 m-t-8 cursor-pointer bg-g-50-hover",
                            on: {
                              click: function ($event) {
                                return _vm.deleteLocalSession(item)
                              },
                            },
                          },
                          [_vm._v("移除会话")]
                        ),
                      ])
                    : _vm._e(),
                  item.scene === "team"
                    ? _c("div", [
                        _c(
                          "p",
                          {
                            staticClass:
                              "p-x-10 p-y-6 m-t-8 cursor-pointer bg-g-50-hover",
                            on: {
                              click: function ($event) {
                                return _vm.addStickTopSession(item)
                              },
                            },
                          },
                          [_vm._v(_vm._s(item.istop ? "取消置顶" : "置顶会话"))]
                        ),
                        _c(
                          "p",
                          {
                            staticClass:
                              "p-x-10 p-y-6 m-t-8 cursor-pointer bg-g-50-hover",
                            on: {
                              click: function ($event) {
                                return _vm.updateInfoInTeamMuteTeam(item)
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                item.muteNotiType == 1
                                  ? "开启消息提醒"
                                  : "消息免打扰"
                              )
                            ),
                          ]
                        ),
                        _c(
                          "p",
                          {
                            staticClass:
                              "p-x-10 p-y-6 m-t-8 cursor-pointer bg-g-50-hover",
                            on: {
                              click: function ($event) {
                                return _vm.deleteLocalSession(item)
                              },
                            },
                          },
                          [_vm._v("移除会话")]
                        ),
                      ])
                    : _vm._e(),
                ]
              ),
            ]
          ),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }